import { Box } from "@mui/material";
import React from "react";
import { Container, Nav, Navbar } from "react-bootstrap";
import { Link, NavLink } from "react-router-dom";
import useAuth from "../../hooks/useAuth";
import logo from "../../images/logo.png";
const Navigation = () => {
  const { user, logOut } = useAuth();
  return (
    <div>
      <Navbar collapseOnSelect expand="lg" bg="dark" variant="dark">
        <Container>
          <NavLink as={Link} to="/home">
            <img src={logo} alt="" />
          </NavLink>
          <Navbar.Toggle aria-controls="responsive-navbar-nav" />
          <Navbar.Collapse id="responsive-navbar-nav">
            <Nav className="ms-auto">
              <Nav.Link as={Link} to="/home">
                Home
              </Nav.Link>
              <Nav.Link as={Link} to="/explore-all">
                Explore All
              </Nav.Link>
              {user?.email && (
                <Nav.Link as={Link} to="/dashboard">
                  Dashboard
                </Nav.Link>
              )}

              {user?.email ? (
                <button className="btn btn-warning" onClick={logOut}>
                  Logout
                </button>
              ) : (
                <Nav.Link as={Link} to="/login">
                  <button
                    className="btn"
                    style={{ backgroundColor: "#f85f13", color: "#fff" }}
                  >
                    Login
                  </button>
                </Nav.Link>
              )}
            </Nav>
          </Navbar.Collapse>
        </Container>
      </Navbar>
    </div>
  );
};

export default Navigation;
